var _g, _path, _path2, _g2, _path3, _path4, _circle, _circle2, _path5, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkraineUkraineSuper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 293 293",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fce438",
    stroke: "#000",
    strokeWidth: 2.78
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 233.09,
    cy: 223.199,
    r: 17.565
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.455,
    cy: 99.219,
    r: 46.983
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.657 89.327H83.444c-8.523 0-15.434 6.91-15.434 15.434v56.448h165.08v-56.448c0-8.523-6.91-15.434-15.434-15.434z",
    fill: "#fc5959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68.01 163.255 3.496-1.961h159.708l1.876 8.015v38.03l-3.411 11.426-4.604 4.434H81.483l-8.783-1.961-4.69-8.953z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.703 89.327H81.483a13.35 13.35 0 0 0-9.475 3.912 13.355 13.355 0 0 0-3.912 9.475v107.012a13.62 13.62 0 0 0 13.472 13.472h138.22a13.26 13.26 0 0 0 8.697-3.24 16.372 16.372 0 0 0 1.279-1.194v-.085a13.327 13.327 0 0 0 3.411-8.953V102.8c-.076-7.409-6.063-13.397-13.472-13.472zm13.387 71.967H68.01"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.908 129.659c-.682 3.581-2.899 5.969-5.798 5.969-3.581 0-6.31-3.667-6.31-8.612s2.643-8.697 6.31-8.697c2.643 0 4.86 2.132 5.798 5.457l6.395-3.411c-1.876-6.31-6.48-10.403-12.193-10.403-7.759 0-13.558 7.333-13.558 17.054s5.884 16.883 13.558 16.883c6.821 0 12.023-5.798 12.961-14.325h-7.163v.085zm23.875-18.844-3.752 13.387-4.86-13.387h-8.186l9.294 22.426c-.767 1.45-1.876 1.961-3.837 1.961h-1.876v8.101h2.302c5.628 0 8.697-2.899 11.341-10.829l7.163-21.743zm11.852 0v32.402h8.527v-24.302h8.527v24.216h8.527V110.73zm39.479 24.643v-4.86h13.472v-7.333h-13.472v-4.775h14.581v-7.674h-22.937v32.402h23.364v-7.759zm33.084-24.643h-13.046v32.402h8.442v-8.953h4.604c6.48 0 11.341-4.946 11.341-11.767s-4.86-11.682-11.341-11.682zm-1.023 15.604h-3.581v-7.845h3.581c2.217 0 3.667 1.62 3.667 3.922s-1.45 3.922-3.667 3.922z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.675 202.223h-9.891l-3.155-14.496-3.24 14.496h-9.891l9.976-23.96h7.077zm68.641-14.666v14.581h-8.015v-13.643c0-2.473-.853-3.581-2.558-3.581-2.217 0-3.325 1.535-3.325 4.434v12.79h-7.759v-13.643q0-3.581-2.558-3.581c-2.132 0-3.325 1.535-3.325 4.434v12.79h-8.015V178.86h5.542l1.108 2.473a8.783 8.783 0 0 1 6.821-3.155 7.666 7.666 0 0 1 6.651 3.411 9.183 9.183 0 0 1 7.163-3.411c5.031 0 8.271 3.837 8.271 9.38zm-41.099 2.558c0-7.418-5.457-12.705-13.217-12.705h-.085c-7.759 0-13.387 5.287-13.387 12.705s5.542 12.705 13.387 12.705H130c7.674 0 13.217-5.287 13.217-12.705zm-13.302 6.566c-3.24 0-5.542-2.729-5.542-6.48s2.388-6.48 5.542-6.48H130c3.155.085 5.457 2.729 5.457 6.48s-2.302 6.48-5.457 6.48zm86.206-6.566c0-7.418-5.457-12.705-13.217-12.705h-.085c-7.759 0-13.387 5.287-13.387 12.705s5.542 12.705 13.387 12.705h.085c7.759 0 13.217-5.287 13.217-12.705zm-13.302 6.566c-3.24 0-5.542-2.729-5.542-6.48s2.388-6.48 5.542-6.48h.085c3.155.085 5.457 2.729 5.457 6.48s-2.302 6.48-5.457 6.48z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.53,
    cy: 174.17,
    r: 27.968,
    fill: "#fce438",
    strokeWidth: 2.78,
    stroke: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.655,
    cy: 171.185,
    r: 4.946
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.445 184.828a1.859 1.859 0 0 0-.256 2.558 2.208 2.208 0 0 0 .938.597c6.736 1.791 21.488 5.116 24.131 2.132s1.279-16.201.426-22.34a1.76 1.76 0 0 0-.693-1.207 1.765 1.765 0 0 0-1.353-.327 1.63 1.63 0 0 0-.853.426zm9.806-15.604a12.756 12.756 0 0 1 .512-2.473c.233-.758.518-1.499.853-2.217a12.4 12.4 0 0 1 2.814-3.837 15.67 15.67 0 0 1 1.876-1.45l1.023-.597 1.023-.512.512-.256.512-.171 1.108-.341 2.217-.426.085.682-2.046.682-1.023.426-.512.256-.512.256-.938.512-.853.682a8.766 8.766 0 0 0-1.45 1.45 9.355 9.355 0 0 0-2.046 3.581 8.339 8.339 0 0 0-.512 1.961 14.17 14.17 0 0 0-.171 1.961z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.375 172.976c-.682-.853-3.24 1.535-6.566 4.178s-6.225 4.69-5.542 5.542 3.922-.682 7.248-3.325 5.457-5.628 4.86-6.395z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.763,
    cy: 168.542,
    r: 0.938
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkraineUkraineSuper);
export default __webpack_public_path__ + "static/media/ukraine_ukraine_super.f68975960d66332316ff4280f9c7a6db.svg";
export { ForwardRef as ReactComponent };